import { useIsIosOs } from '@/app/providers/ConfigProvider';
import classNames from 'classnames';

type TabButtonProps = {
  isActive?: boolean;
  title: string;
  onClick?: () => void;
};

export const TabButton = ({ isActive, title, onClick }: TabButtonProps) => {
  const isIosOs = useIsIosOs();

  const iosActiveStyles = 'active:text-donationsTabButton-pressed-text active:bg-donationsTabButton-pressed-bg';

  const otherPlatformsStyles = [
    'hover:text-donationsTabButton-hover-text hover:bg-donationsTabButton-hover-bg',
    'active:text-donationsTabButton-pressed-text active: active:bg-donationsTabButton-pressed-bg',
  ];

  return (
    <button
      className={classNames(
        'text-[14px]  px-[14px] rounded-[100px] lg:px-[16px] leading-[32px] lg:leading-[40px] ',
        isIosOs ? iosActiveStyles : otherPlatformsStyles,
        {
          'text-donationsTabButton-active-text bg-donationsTabButton-active-bg': isActive,
          'text-donationsTabButton-default-text bg-donationsTabButton-default-bg': !isActive,
        },
      )}
      onClick={onClick}
    >
      {title}
    </button>
  );
};
